export default "__VITE_ASSET__CI_7nch2__"